import { ChertoExperiments } from 'constants/experiments'
import SocialProofDialog from 'components/OfferPage/SocialProofDialog'
import { SOCIAL_PROOF_COPY_VARIANTS } from 'hooks/OfferPage/useSocialProofPopup'

interface Props {
  offer: App.Offer
}

function FlashHotelSocialProofDialog({ offer }: Props) {
  return (
    <SocialProofDialog
      copyVariant={SOCIAL_PROOF_COPY_VARIANTS.flashHotel}
      experiment={ChertoExperiments.croSocialProofRecentPurchase}
      offerImage={offer.image}
      recentPurchases={offer.stats?.recentPurchases}
    />
  )
}

export default FlashHotelSocialProofDialog
